module.exports = __webpack_public_path__ + "img/unknown.0a04d678.svg";